<template>
    <div>
        <div v-if="emptyFiles">
            {{ $t("shared-files.empty") }}
        </div>
        <div v-else>
            <div class="columns is-multiline">
                <template v-for="file in files">
                    <div class="column is-3" :key="file.id">
                        <SharedFile :file="file" />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import SharedFile from "./SharedFile.vue";

export default {
    name: "shared-files",
    components: {
        SharedFile,
    },
    props: {
        roomId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            files: [],
        };
    },
    mounted() {
        this.retrieveFiles();
    },
    computed: {
        emptyFiles() {
            return this.files.length === 0;
        },
    },
    methods: {
        async retrieveFiles() {
            let response = await RepositoryFactory.files.getFiles({
                roomId: this.roomId,
            });
            this.files = response.data;
        },
    },
};
</script>